<template>
  <c-row>
    <c-col col="5">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Input Gaji Karyawan</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div class="form-group">
            <label>Tanggal</label>
            <datetime
              class="date-control"
              format="dd MMMM yyyy"
              type="date"
              v-bind:class="{ 'has-error': errors.date }"
              v-model="salary.date"
              placeholder="Tanggal"
            />
          </div>
          <div class="form-group">
            <label>Nama Karyawan</label>
            <input
              type="text"
              class="form-control"
              v-model="salary.employee_name"
            />
          </div>
          <div class="form-group">
            <label>Gaji Pokok</label>
            <button-edit-input-2
              v-model="salary.basic_salary"
              v-bind:class="{ 'has-error': errors.basic_salary }"
              :rounded="true"
              :bordered="true"
            />
          </div>
          <table class="table table-bordered">
            <tbody v-for="(v, k) in salaryItems" :key="k">
              <tr v-if="k == '+'">
                <td colspan="3"><strong>Tunjangan</strong></td>
              </tr>
              <tr v-else>
                <td colspan="3"><strong>Potongan</strong></td>
              </tr>
              <tr v-for="(vv, kk) in v" :key="kk + k">
                <td>- {{ vv.name }}</td>
                <td style="width: 263px">
                  <button-edit-input-2
                    v-model="vv.amount"
                    v-bind:class="{ 'has-error': errors.basic_salary }"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
        <c-card-footer>
          <button class="btn-success btn" @click="save">Save</button>
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="7">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong style="float: left; line-height: 35px"
              >Gaji Karyawan</strong
            >
          </c-card-title>
          <div class="card-header-actions">
            <datetime
              style="float: left"
              class="date-control mr-2"
              format="MMMM yyyy"
              type="date"
              v-bind:class="{ 'has-error': errors.date }"
              v-model="filter.date"
              placeholder="Filter Bulan"
              :flow="['year', 'month']"
            />
            <button class="btn btn-primary" @click="applyFilter">Apply</button>
          </div>
        </c-card-header>
        <c-card-body>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>No</th>
                <th>Bulan</th>
                <th>Nama Karyawan</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody v-for="(d, k) in salaries" :key="k">
              <tr>
                <td :rowspan="d.items.length + 2">
                  <table-number
                    :page="paginate.page"
                    :size="paginate.per_page"
                    :index="k"
                  />
                </td>
                <td :rowspan="d.items.length + 1">
                  <strong>{{ d.employee_name }}</strong
                  ><br />
                  {{ d.month | monthFormat }}
                </td>
                <td>Gaji Pokok</td>
                <td class="right">{{ d.basic_salary | thousandSeparator }}</td>
              </tr>
              <tr v-for="(dd, kk) in d.items" :key="k + kk">
                <td>{{ dd.label }}</td>
                <td class="right">{{ dd.amount | thousandSeparator }}</td>
              </tr>
              <tr>
                <td class="bold right bg-gray" colspan="2">Total</td>
                <td class="bold right bg-gray">
                  {{ d.total | thousandSeparator }}
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
import { showErrorMessage } from "../../lib/helpers";
import TableNumber from "../../components/TableNumber";
import ButtonEditInput2 from "../../components/ButtonEditInput2";
export default {
  components: {
    TableNumber,
    ButtonEditInput2,
  },
  data () {
    return {
      filter: {
        date: null
      },
      salary: {
        date: null,
        basic_salary: 0,
        allowance: 0
      },
      salaries: [],
      paginate: {},
      errors: [],
      salaryItems: [],
    };
  },
  created () {
    this.getList(1);
    this.getSalaryItem()
  },
  methods: {
    save () {
      this.salary.items = this.salaryItems
      HTTPAUTH.post("/api/v1/salary", this.salary)
        .then(() => {
          this.$toasted.success("Berhasil ditambahkan").goAway();
          this.getList(1);
          this.salary = {};
          this.getSalaryItem();
        })
        .catch((eres) => {
          this.errors = showErrorMessage(eres);
        });
    },
    getList (page, month) {
      if (!month) {
        month = moment().format('YYYY-MM')
      }
      HTTPAUTH.get(`/api/v1/salary?size=10&page=${page}&month=${month}`)
        .then((res) => {
          this.salaries = res.data.data;
          this.paginate = res.data.paginate;
        })
        .catch((eres) => {
          this.errors = showErrorMessage(eres);
        });
    },
    setBasicSalary (b) {
      console.log(b);
    },
    getSalaryItem () {
      HTTPAUTH.get(`/api/v1/salary-item/active/items`).then(res => {
        this.salaryItems = res.data.data;
      }).catch(eres => {
        showErrorMessage(eres)
      })
    },
    applyFilter () {
      if (this.filter.date) {
        const month = moment(this.filter.date).format('YYYY-MM');
        this.getList(1, month)
      }
    }
  },
};
</script>